// Mirrors canReadComplaints in p3kln-bo-service: "Pusat Bantuan" is
// read-only for Superadmin, Admin and Verifikator.
export const COMPLAINT_READER_POSITIONS = ["superadmin", "admin", "verifikator"];

export const canReadComplaints = (position) =>
  COMPLAINT_READER_POSITIONS.includes((position || "").trim().toLowerCase());
